export const getPixelValueOfRem = (): number =>
  parseFloat(getComputedStyle(document.documentElement).fontSize);

export const convertRemToPixels = (rem: number): number =>
  rem * getPixelValueOfRem();
